package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Photo attachée à un arbre (#223, lot A photos).
 *
 * [id] est un UUID en texte plutôt qu'un `Long` : la ligne est adressable dans une URL publique
 * (galerie, suppression) et un identifiant énumérable y exposerait le volume/l'ordre d'upload.
 * [createdAt] suit la convention des autres timestamps du contrat : epoch millis.
 */
@Serializable
data class TreePhotoDto(
    val id: String,
    val fullUrl: String,
    val thumbUrl: String,
    val width: Int,
    val height: Int,
    val authorId: Long,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val createdAt: Instant,
)
